module.exports = __webpack_public_path__ + "img/icn_user_actived.4d43a21e.svg";